import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Typography, Empty, Row, Col, Button } from "antd";
import { StarFilled, MessageOutlined } from "@ant-design/icons";

const { Paragraph, Text, Title } = Typography;

const AllFeedbacks = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { ratings = [], darkMode = false } = location.state || {};

  const cardStyle = {
    margin: 24,
    borderRadius: 12,
    backgroundColor: darkMode ? "#001529" : "#fafafa",
    borderColor: darkMode ? "#1890ff66" : "#d9d9d9",
  };

  const feedbackBoxStyle = {
    padding: 16,
    borderRadius: 10,
    marginBottom: 20,
    backgroundColor: darkMode ? "#003a8c" : "#ffffff",
    boxShadow: darkMode ? "0 2px 4px rgba(0,0,0,0.4)" : "0 1px 3px rgba(0,0,0,0.1)",
  };

  return (
    <Card
      style={cardStyle}
      title={
        <Title level={4} style={{ margin: 0, color: darkMode ? "#fff" : "#000" }}>
          <MessageOutlined style={{ marginRight: 8, color: "#1890ff" }} />
          All Feedback
        </Title>
      }
      extra={
        <Button type="default" onClick={() => navigate(-1)}>
          Back
        </Button>
      }
    >
      {ratings.length > 0 ? (
        ratings.map((rating, index) => (
          <div key={rating.learnerId || index} style={feedbackBoxStyle}>
            <Paragraph
              italic
              style={{
                color: darkMode ? "#e6f7ff" : "#333",
                fontSize: 16,
                marginBottom: 12,
              }}
            >
              {rating.feedback}
            </Paragraph>

            <Row justify="space-between" align="middle">
              <Col>
                <Text strong style={{ color: darkMode ? "#ffffff" : "#000000" }}>
                  — {rating.learnerName}
                </Text>
              </Col>
              <Col>
                {Array.from({ length: rating.rating || 0 }).map((_, i) => (
                  <StarFilled key={i} style={{ color: "#faad14", fontSize: 16 }} />
                ))}
              </Col>
            </Row>
          </div>
        ))
      ) : (
        <Empty description="No feedback available" />
      )}
    </Card>
  );
};

export default AllFeedbacks;
